import {
  Box,
  Breadcrumbs,
  Button,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import AlertDialog from '../dashboard/AlertDialog';
import {withNavigation} from '../navigation/navigation';
import {useUserSubscription} from './hook/useUserSubscription';

const UserSubscription = ({setShowNav}) => {
  useEffect(() => setShowNav(false), []);

  const {
    getCurrentSubscription,
    getSubscriptionHistory,
    isLoading,
    cancelCurrent,
    canRenew,
  } = useUserSubscription();
  const {mode} = useDarkMode();
  const current = getCurrentSubscription();
  const histories = getSubscriptionHistory();
  const nav = useNavigate();
  const [confirmCancel, setConfirmCancel] = useState(false);

  return (
    <Stack
      sx={{
        width: '75%',
        backgroundColor: mode.settings.cardBackgroundColor,
        padding: '25px',
      }}>
      <Breadcrumbs
        separator="›"
        aria-label="breadcrumb"
        style={{
          color: mode.settings.textColor3,
          paddingTop: 15,
          paddingBottom: 15,
        }}>
        {[
          <Typography
            className={'breadcrumbs'}
            variant={'body2'}
            onClick={() => nav('/')}
            style={{color: mode.settings.breadcrumbColor1}}>
            Accueil
          </Typography>,
          <Typography
            className={'breadcrumbs'}
            variant={'body2'}
            onClick={() => nav('/profile')}
            style={{color: mode.settings.breadcrumbColor1}}>
            Mon compte
          </Typography>,
          <Typography
            className={'breadcrumbs'}
            variant={'body2'}
            style={{color: mode.settings.textColor3}}>
            Mon abonnement
          </Typography>,
        ]}
      </Breadcrumbs>
      <Stack
        sx={{marginBottom: 2}}
        justifyContent="space-between"
        direction="row">
        <Typography variant={'h2'} color={mode.settings.textColor6}>
          Abonnement
        </Typography>
      </Stack>
      <Stack spacing={2}>
        <Typography
          variant={'h3'}
          component="span"
          color={mode.settings.textColor3}>
          Votre Abonnement actuel
        </Typography>
        {current && !isLoading && (
          <>
            <SubscriptionItem {...current} />
            <Stack direction="row" spacing={2}>
              {!isLoading && canRenew() && (
                <Button
                  className="btn"
                  onClick={() => nav('/subscription-choice')}>
                  <Typography variant={'subtitle3'} component="span">
                    Renouveler mon abonnement
                  </Typography>
                </Button>
              )}
              {'' === current.initiatorName && (
                <Button
                  className={current.isCancelled ? 'btnGrey' : 'btn'}
                  disabled={current.isCancelled}
                  onClick={() => setConfirmCancel(c => !c)}>
                  <Typography variant={'subtitle3'} component="span">
                    Annuler maintenant
                  </Typography>
                </Button>
              )}
            </Stack>
            <AlertDialog
                handleAccept={() => { cancelCurrent().then(() => { setConfirmCancel(false); }); }}
              handleClose={() => setConfirmCancel(false)}
              text={'Voulez-vous vraiment annuler votre abonnement en cours ?'}
              open={confirmCancel}
              isLoading={isLoading}
            />
          </>
        )}
        {!current && !isLoading && (
          <>
            <Typography color={mode.settings.textColor3}>
              Vous n'avez pas d'abonnement
            </Typography>
            <Button
              className="btn"
              onClick={() => nav('/subscription-choice')}
              sx={{alignSelf: 'flex-start'}}>
              <Typography variant={'subtitle3'} component="span">
                Abonner vous maintenant
              </Typography>
            </Button>
          </>
        )}
      </Stack>
    </Stack>
  );
};

const SubscriptionItem = ({title, startDate, endDate, initiatorName}) => {
  const {mode} = useDarkMode();

  return (
    <>
      {'' === initiatorName && (
        <Box
          sx={{
            padding: '15px',
            borderRadius: '5px',
            boxShadow: '4px 3px 8px 1px #9696966b',
            width: '215px',
          }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            spacing={2}
            sx={{width: '100%'}}>
            <Typography color={mode.settings.textColor3}>{title}</Typography>
          </Stack>
          <hr />
          <Typography color={mode.settings.textColor3}>
            <span style={{fontWeight: 'bold'}}>Début</span> {startDate}
          </Typography>
          <Typography color={mode.settings.textColor3}>
            <span style={{fontWeight: 'bold'}}>Fin</span> {endDate}
          </Typography>
        </Box>
      )}
      {'' !== initiatorName && (
        <Typography color={mode.settings.textColor3}>
          Votre abonnement est lié à celui de votre compte racine &nbsp;
          <span style={{fontWeight: 'bold'}}>{initiatorName}</span>
        </Typography>
      )}
    </>
  );
};

const Placeholder = () => {
  return (
    <Box
      sx={{
        padding: '15px',
        borderRadius: '5px',
        boxShadow: '4px 3px 8px 1px #9696966b',
        width: '215px',
      }}>
      <Skeleton width={100} height={20} />
      <hr />
      <Skeleton width={110} height={20} />
      <Skeleton width={110} height={20} />
    </Box>
  );
};

export default withNavigation(UserSubscription);
